import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/authStore'

// 布局组件
const Layout = () => import('@/layout/index.vue')

// 预加载常用组件
const preloadComponents = () => {
  const commonViews = ['Dashboard/index', 'work-order/list', 'membership/management', 'data-query/history']

  commonViews.forEach((view) => {
    import(`@/views/${view}.vue`)
  })
}

// 工单管理相关路由
const WorkOrderRoutes = [
  {
    path: '/work-order',
    component: Layout,
    redirect: '/work-order/create',
    name: 'WorkOrder',
    meta: { title: '工单管理', icon: 'document' },
    children: [
      {
        path: 'create',
        name: 'WorkOrderCreate',
        component: () => import('@/views/work-order/create.vue'),
        meta: { title: '新建工单', icon: 'edit' }
      },
      {
        path: 'edit/:id',
        name: 'WorkOrderEdit',
        component: () => import('@/views/work-order/edit.vue'),
        meta: { title: '修改工单', icon: 'edit' },
        hidden: true,
        props: route => ({ id: route.params.id, mode: 'edit' })
      },
      {
        path: 'list',
        name: 'WorkOrderList',
        component: () => import('@/views/work-order/list.vue'),
        meta: { title: '工单列表', keepAlive: true }
      },
      {
        path: 'detail/:id',
        name: 'WorkOrderDetailOriginal',
        component: () => import('@/views/work-order/detail.vue'),
        meta: { title: '工单详情 (旧)', activeMenu: '/work-order/list' },
        hidden: true
      },
      {
        path: 'view/:id',
        name: 'WorkOrderView',
        component: () => import('@/views/work-order/edit.vue'),
        meta: { title: '查看工单', activeMenu: '/work-order/list' },
        hidden: true,
        props: route => ({ id: route.params.id, mode: 'view' })
      },
      {
        path: 'detection/:id/:status',
        name: 'Detection',
        component: () => import('@/views/vehicle-inspection/detection.vue'),
        meta: { title: '检测流程' },
        hidden: true
      },
      {
        path: 'result/:id',
        name: 'InspectionResult',
        component: () => import('@/views/vehicle-inspection/result.vue'),
        meta: { title: '检测结果' },
        hidden: true
      }
    ]
  }
]

// 车辆检测相关路由
const VehicleInspectionRoutes = [
  {
    path: '/vehicle-inspection',
    component: Layout,
    redirect: '/vehicle-inspection/command-test',
    name: 'VehicleInspection',
    meta: { title: '车辆检测', icon: 'tools' },
    hidden: false,
    children: [
      // {
      //   path: 'preparation',
      //   name: 'InspectionPreparation',
      //   component: () => import('@/views/vehicle-inspection/preparation.vue'),
      //   meta: { title: '检测准备' }
      // },
      // {
      //   path: 'detection/:id/:status',
      //   name: 'Detection',
      //   component: () => import('@/views/vehicle-inspection/detection.vue'),
      //   meta: { title: '检测流程' },
      //   hidden: true
      // },
      // {
      //   path: 'process',
      //   name: 'InspectionProcess',
      //   component: () => import('@/views/vehicle-inspection/process.vue'),
      //   meta: { title: '检测流程' }
      // },
      // {
      //   path: 'result/:id',
      //   name: 'InspectionResult',
      //   component: () => import('@/views/vehicle-inspection/result.vue'),
      //   meta: { title: '检测结果' },
      //   hidden: true
      // }
      // {
      //   path: 'comparison',
      //   name: 'InspectionComparison',
      //   component: () => import('@/views/vehicle-inspection/comparison.vue'),
      //   meta: { title: '维修前后对比' }
      // }
      {
        path: 'command-test',
        name: 'CommandTest',
        component: () => import('@/views/vehicle-inspection/command-test.vue'),
        meta: { title: '系统管理' }
      }
    ]
  }
]

// 数据查询相关路由
const DataQueryRoutes = [
  {
    path: '/data-query',
    component: Layout,
    redirect: '/data-query/history',
    name: 'DataQuery',
    meta: { title: '数据查询', icon: 'search' },
    children: [
      {
        path: 'history',
        name: 'HistoryData',
        component: () => import('@/views/data-query/history.vue'),
        meta: { title: '数据查询' }
      },
      {
        path: 'report/:id',
        name: 'InspectionReport',
        component: () => import('@/views/data-query/report.vue'),
        meta: { title: '维修前后数据' },
        hidden: true
      },
      {
        path: 'history-data/result/:id',
        name: 'HistoricalInspectionResult',
        component: () => import('@/views/vehicle-inspection/result.vue'),
        meta: { title: '检测结果', activeMenu: '/data-query/history' },
        hidden: true,
        props: true
      },
      {
        path: 'history-data/:id',
        name: 'historyData',
        component: () => import('@/views/data-query/history-data.vue'),
        meta: { title: '检测历史记录' },
        hidden: true
      }
    ]
  }
]

// 新增：报告对比页面路由，不显示在菜单中
const CompareReportsRoute = {
  path: '/data-query/compare-reports',
  name: 'CompareReports',
  component: () => import('@/views/data-query/compare-reports.vue'),
  meta: { title: '报告对比' },
  hidden: true
};

const MessageRoute = {
  path: '/data-query/message/:id',
  name: 'Message',
  component: () => import('@/views/data-query/message.vue'),
  meta: { title: '检测报告' },
  hidden: true
}

const h5 = {
  path: '/h5-add',
  name: 'H5Add',
  component: () => import('@/views/work-order/h5-add.vue'),
  meta: { title: '新增工单' },
  hidden: true
}

// 会员与充值相关路由
const MembershipRoutes = [
  {
    path: '/membership',
    component: Layout,
    redirect: '/membership/management',
    name: 'MembershipRoot',
    meta: { title: '会员管理', icon: 'user', roles: [1] },
    children: [
      {
        path: 'management',
        name: 'MembershipManagement',
        component: () => import('@/views/membership/index.vue'),
        meta: { title: '会员信息管理', roles: [1] }
      }
    ]
  }
];

// 系统管理相关路由
const SystemRoutes = [
  {
    path: '/system',
    component: Layout,
    redirect: '/system/user',
    name: 'System',
    meta: { title: '系统管理', icon: 'setting', roles: [1] },
    children: [
      {
        path: 'user',
        name: 'UserManagement',
        component: () => import('@/views/system/user.vue'),
        meta: { title: '用户管理' }
      },
      {
        path: 'user-ip-management/:userId',
        name: 'UserIpManagement',
        component: () => import('@/views/system/UserIpManagement.vue'),
        meta: { title: '用户IP白名单管理', activeMenu: '/system/user' },
        hidden: true,
        props: true
      }
      // {
      //   path: 'device',
      //   name: 'DeviceManagement',
      //   component: () => import('@/views/system/device.vue'),
      //   meta: { title: '设备管理' }
      // }
      // {
      //   path: 'standard',
      //   name: 'StandardManagement',
      //   component: () => import('@/views/system/standard.vue'),
      //   meta: { title: '排放标准管理' }
      // }
    ]
  }
]

// 登录页面
const LoginRoute = {
  path: '/login',
  name: 'Login',
  component: () => import('@/views/Login/index.vue'),
  meta: { title: '登录' },
  hidden: true
}

// 首页
const HomeRoute = {
  path: '/',
  component: Layout,
  redirect: '/dashboard',
  children: [
    {
      path: 'dashboard',
      name: 'Dashboard',
      component: () => import('@/views/Dashboard/index.vue'),
      meta: { title: '首页', icon: 'home' }
    }
  ]
}

// 404页面
const NotFoundRoute = {
  path: '/:pathMatch(.*)*',
  name: 'NotFound',
  component: () => import('@/views/error/404.vue'),
  meta: { title: '404' },
  hidden: true
}

// 创建路由器实例
const router = createRouter({
  history: createWebHistory('/'),
  routes: [HomeRoute, ...WorkOrderRoutes, ...VehicleInspectionRoutes, ...DataQueryRoutes, ...MembershipRoutes, ...SystemRoutes, LoginRoute, NotFoundRoute, MessageRoute, h5, CompareReportsRoute],
  scrollBehavior() {
    return { top: 0 }
  }
})

// 全局前置守卫
router.beforeEach((to, from, next) => {
  const authStore = useAuthStore()
  const isLoggedIn = !!authStore.token
  document.title = to.meta.title || '汽车尾气检测'
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
  // 不需要登录的页面

  // 手机端特定页面
  const mobileTargetRoute = '/h5-add'

  const noAuthRoutes = ['/login', '/404']
  if (noAuthRoutes.includes(to.path) && isLoggedIn) {
    next({ path: '/' })
    return
  }

  if (!noAuthRoutes.includes(to.path) && !isLoggedIn) {
    next({ path: '/login', query: { redirect: to.fullPath } })
    return
  }

  // 如果已登录且是手机端，强制跳转到手机端特定页面
  if (isLoggedIn && isMobile && to.path !== mobileTargetRoute) {
    next({ path: mobileTargetRoute })
    return
  }

  next()
})

// 添加预加载函数到路由器实例
router.preloadComponents = preloadComponents

// 在导出前确保其它路由也被正确应用
export default router
